import React from 'react';
import { TBaseHamburgerProps } from './BaseHamburger.types';
import s from './BaseHamburger.module.scss';

export const BaseHamburger: React.FC<TBaseHamburgerProps> = ({ isOpened, className, onClick }) => {
  return (
    <button
      className={`${s.button} ${isOpened ? s.opened : ''} ${className}`}
      type="button"
      onClick={onClick}>
      <div className={s.line} />
      <div className={s.line} />
      <div className={s.line} />
    </button>
  );
};
